import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

export default function CompetitionRulesPage() {
  return (
    <div className="min-h-screen bg-black flex flex-col">
      <Navigation />
      <main className="flex-1 pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-white mb-10">
            Official Rules: "Weekly Winner" Strategy Competition
          </h1>

          <div className="prose prose-invert prose-sm max-w-none space-y-8 text-gray-300 leading-relaxed">
            <p className="font-semibold text-gray-200">
              NO PURCHASE NECESSARY TO ENTER OR WIN. A PURCHASE DOES NOT INCREASE YOUR
              CHANCES OF WINNING.
            </p>

            {/* Section 1 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Eligibility</h2>
              <p>
                Open to registered users of Propalgos.ai who are legal residents of eligible
                jurisdictions and at least 18 years old. Void in Quebec, Italy, Brazil, and
                where prohibited by law.
              </p>
            </section>

            {/* Section 2 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. How to Enter</h2>

              <h3 className="text-base font-medium text-gray-200 mt-4 mb-2">Standard Method</h3>
              <p>
                Use Platform Credits to run a backtest and submit the resulting strategy
                report via the "Competition" dashboard.
              </p>

              <h3 className="text-base font-medium text-gray-200 mt-4 mb-2">
                Alternative Method of Entry (AMOE)
              </h3>
              <p>
                To enter without using Credits, send an email to{' '}
                <a
                  href="mailto:contests@propalgos.ai"
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                >
                  contests@propalgos.ai
                </a>{' '}
                with the subject line "Weekly Winner Entry," including a written description
                (min. 500 words) of a trading strategy logic, parameters, and risk management
                rules. AMOE entries will be backtested by Sponsor using standard parameters
                and entered into judging on equal footing.
              </p>
            </section>

            {/* Section 3 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Contest Period</h2>
              <p>
                Weekly, commencing Monday 00:00 UTC and ending Sunday 23:59 UTC.
              </p>
            </section>

            {/* Section 4 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Judging Criteria (Skill Test)</h2>
              <p className="mb-4">
                Winners are determined <strong className="text-white">not by random draw</strong> and{' '}
                <strong className="text-white">not solely by highest simulated return</strong> (which
                may be attributed to luck/variance). All entries will be evaluated by a panel
                of judges (or a programmed scoring algorithm) based on the following weighted
                criteria:
              </p>
              <ol className="list-decimal list-inside space-y-3 text-gray-400">
                <li>
                  <strong className="text-gray-300">Risk-Adjusted Return (Sharpe Ratio)</strong>{' '}
                  <span className="text-white font-medium">(40%)</span> — Measuring return per
                  unit of risk.
                </li>
                <li>
                  <strong className="text-gray-300">Maximum Drawdown</strong>{' '}
                  <span className="text-white font-medium">(30%)</span> — Evaluating capital
                  preservation and stability.
                </li>
                <li>
                  <strong className="text-gray-300">Strategy Robustness</strong>{' '}
                  <span className="text-white font-medium">(20%)</span> — Performance across
                  diverse market regimes (R-Squared/Consistency).
                </li>
                <li>
                  <strong className="text-gray-300">Code/Logic Quality</strong>{' '}
                  <span className="text-white font-medium">(10%)</span> — Efficiency and
                  clarity of the submitted algorithm.
                </li>
              </ol>
            </section>

            {/* Section 5 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Winner Selection</h2>
              <p>
                The entrant with the highest aggregate score based on the criteria above will
                be declared the potential winner. In the event of a tie, the entrant with the
                lower Maximum Drawdown will win.
              </p>
              <div className="bg-gray-900 border border-gray-700 rounded-lg p-4 mt-4">
                <h3 className="text-sm font-semibold text-gray-300 mb-2">
                  For Canadian Residents Only
                </h3>
                <p className="text-gray-400 text-sm">
                  Before being declared a winner, a selected entrant must correctly answer,
                  without assistance of any kind, whether mechanical or otherwise, a
                  time-limited mathematical skill-testing question (e.g., 20 + (10 &times; 3) &minus; 5 = ?)
                  to be administered by telephone or email.
                </p>
              </div>
            </section>

            {/* Section 6 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Prizes</h2>
              <p>
                Weekly Prize: $100 USD (or credit equivalent). Prizes are non-transferable.
                Winners are responsible for all applicable taxes.
              </p>
            </section>

            {/* Section 7 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Intellectual Property</h2>
              <p>
                By entering, you grant Propalgos a perpetual, non-exclusive, royalty-free
                license to display your strategy's performance graph, metadata (e.g., asset
                class, timeframe), and username on our Leaderboard and marketing materials.
                You retain ownership of the specific underlying source code.
              </p>
            </section>

            {/* Section 8 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. General Conditions</h2>
              <p>
                Propalgos reserves the right to disqualify any entry that utilizes exploits,
                curve-fitting (overfitting) deemed excessive by judges, or violates the
                Acceptable Use Policy.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
